import { forwardRef } from 'react';
import { jsxs, jsx } from 'react/jsx-runtime';

const SvgCriticalIllness = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId,
    ...props,
    children: [title ? /*#__PURE__*/jsx("title", {
      id: titleId,
      children: title
    }) : null, /*#__PURE__*/jsx("path", {
      d: "M52.627 9.239A14.72 14.72 0 0 0 41.9 4.649a14.7 14.7 0 0 0-10.636 4.589L29.979 10.6l-1.31-1.362a14.643 14.643 0 0 0-20.693-.61q-.317.3-.612.611a15.86 15.86 0 0 0-.474 21.337L29.977 57l23.116-26.395a15.86 15.86 0 0 0-.466-21.366M29.981 49.406l-14.91-17.065-.041-.048 5.846-5.848 9.8 9.806 5.929-5.93h10.086l-.048.06zm20.71-24.085H34.536l-3.857 3.858-9.8-9.807-9.143 9.147-.022-.024-1.044-1.2A10.87 10.87 0 0 1 11 12.672q.192-.204.4-.4a9.64 9.64 0 0 1 13.646.418l4.965 5.156 4.889-5.174a9.72 9.72 0 0 1 14.094 0 10.87 10.87 0 0 1 1.697 12.649",
      fill: "currentColor"
    })]
  });
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCriticalIllness);
var ForwardRef$1 = ForwardRef;

export { ForwardRef$1 as default };
